export const socketApiKey = process.env.REACT_APP_SOCKET_KEY || '';
export const socketSecretKey = process.env.REACT_APP_SOCKET_SECRET_KEY || '';
export const socketUrl = process.env.REACT_APP_SOCKET_URL || '';
